/* eslint-disable react-hooks/exhaustive-deps */
/****************************************************
FilterFacets.tsx - Filter Facets for chemical & glove selector
*****************************************************/
import React, { useState, useEffect, useCallback } from "react";
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { BsSearch } from 'react-icons/bs';
import { AiOutlineClose } from 'react-icons/ai';
import { FACETS_CHEMICAL_BASE_QUERY, FACETS_GLOVE_BASE_QUERY, REGEX_ITEMS } from "../../../../helper/constants";
import { useTranslation } from "react-i18next";
import Loader from "../../../common/Loader/Loader";
import { useGetFacetResultsQuery } from "../../../../services/getFacets";
import { useGetStyleNumbersQuery } from "../../../../services/loadStyleNumbers";
import { setGloveResultsInStore } from "../../../../store/actions";
import { ImgAlert } from "../../../../components/dashboard/pages/glovesSelector/glovesSelection";
import Modal from 'react-bootstrap/Modal';
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { kclRootState } from "../../../../store/gloveSelectorStore";
import { setFilterFacets } from "../../../../store/actions";
import {
    orderBy,
} from 'lodash';
import ChemicalResultsPDF from "../chemicalResults/chemicalResultsPDF/ChemicalResultsPDF";
import { data, facetFlters, facetColumnData, expandedFilters, showMoreFacetItems, facetSearchText } from "../../../../types/allTypes";
import { utilAnalytics } from "../../../common/analytics/analyticsUtil";
const FilterFacets = (props) => {

    const { t } = useTranslation();
    const facetKeySeperator = "#KEY#";
    const [showMoreFacetItemsPanel, setShowMoreFacetItemsPanel] = useState<showMoreFacetItems>({});
    const [showMobileFilters, setShowMobileFilters] = useState<boolean>(true);
    const [expandedFilters, setExpandedFilters] = useState<expandedFilters>({});
    const [selectedfacetQueryFilters, setSelectedfacetQueryFilters] = useState<facetFlters>([]);
    const [checkedFacet, setCheckedFacet] = useState<string[]>([]);
    const [facetSearchText, setFacetSearchText] = useState<facetSearchText>({});
    const [facetPanelSearchText, setFacetPanelSearchText] = useState<facetSearchText>({});
    const [refreshKey, setRefreshKey] = useState<number>(Date.now());
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [currentFacet, setCurrentFacet] = useState<string>("");
    const closeWarning = () => setShowAlert(false);
    const [sucessMsg, setSucessMsg] = useState<boolean>(true);
    const [dataFacetResults, setDataFacetResults] = useState<data>(null);
    const [filteredFacetResults, setFilteredFacetResults] = useState<data>(null);
    const { PAGE_NAVIGATION, FACET_FLOWS, FACET_YES_VALUES } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});
    const language = useSelector((state: kclRootState) => state?.glovesSelector?.language || "en-US"
    );
    const navigate = useNavigate();
    const location = useLocation();
    const colorCodeAvailable = ["beige", "black", "blau", "blue", "curry", "gelb", "grau", "green", "grey", "grün", "orange", "red", "redbrown", "reddishbrown", "rot", "rotbraun", "schwarz", "transparent", "weiß", "white", "yellow", "purple", "dark-grey", "dunkel-grau", "dunkel-blau", "dark-blue", "yellow-grey", "gelb-grau", "neon-gelb", "hell-grau", "neon-yellow"];
    const styleNumbersData = useSelector((state: kclRootState) => state?.glovesSelector?.calculator?.styleNumberArray || []);
    const filterFacets = useSelector((state: kclRootState) => state?.glovesSelector?.setFilterFacets || {});
    //All facets config
    const GroupedFacetList = {
        specifications: [
            { label: t("filterFacets.Silicon_Free"), column: 'silicon_free', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Clean_Room"), column: 'clean_room_capability', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Touch_Screen"), column: 'touch_screen_capacitive', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Velourised"), column: 'velourised', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Includes_Liner"), column: 'lncludes_liner', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Washable"), column: 'washable', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Latex_Free"), column: 'latex_free', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Microorganism"), column: 'microorganism_protection', type: 'checkbox', multiselect: false, group: 'specifications' },

            { label: t("filterFacets.Virus_Protection"), column: 'virus_protection', maxItems: 8, type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Medical_Devices"), column: 'medical_devices', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Antistatics"), column: 'antistatics_en_16350', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Food_Certifications"), column: 'food_certifications', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Type_Welding"), column: 'type_en_12477_welding', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.OEKO_TEX"), column: 'oeko_tex_100_class', type: 'checkbox', multiselect: false, group: 'specifications' },
            { label: t("filterFacets.Tested_421"), column: 'tested_for_421', type: 'checkbox', multiselect: false, group: 'specifications' }

        ],
        en374: [
            { label: t("filterFacets.Test_Chemical"), column: 'test_chemicals', type: 'checkbox', multiselect: true, group: 'en374' },
            { label: t("filterFacets.Type"), column: 'type', type: 'checkbox', multiselect: true, group: 'en374' },
            { label: t("filterFacets.AQL"), column: 'aql_penetration_resistance', type: 'checkbox', multiselect: true, group: 'en374' },
        ],
        en388: [
            { label: t("filterFacets.Abrasion"), column: 'abrasion_resistance', type: 'checkbox', multiselect: true, group: 'en388' },
            { label: t("filterFacets.Cut_Protection_Level"), column: 'cut_protection_level', type: 'checkbox', multiselect: true, group: 'en388' },
            { label: t("filterFacets.Tear_Resistance"), column: 'tear_resistance', type: 'checkbox', multiselect: true, group: 'en388' },
            { label: t("filterFacets.Puncture_Resistance"), column: 'puncture_resistance', type: 'checkbox', multiselect: true, group: 'en388' },
            { label: t("filterFacets.Cut_Resistance"), column: 'cut_resistance_iso_13997_ansi_isea', type: 'checkbox', multiselect: true, group: 'en388' },
            { label: t("filterFacets.Impact_Protection"), column: 'impact_protection', maxItems: 8, type: 'checkbox', multiselect: false, group: 'en388' }
        ],
        en407: [
            { label: t("filterFacets.Limited_Flame"), column: 'limited_flame_spread', type: 'checkbox', multiselect: true, group: 'en407' },
            { label: t("filterFacets.Contect_Heat"), column: 'contact_heat', type: 'checkbox', multiselect: true, group: 'en407' },
            { label: t("filterFacets.Convective_Heat"), column: 'convective_heat', type: 'checkbox', multiselect: true, group: 'en407' },
            { label: t("filterFacets.Radiant_Heat"), column: 'radiant_heat', type: 'checkbox', multiselect: true, group: 'en407' },
            { label: t("filterFacets.Molten_Metal_Small"), column: 'molten_metal_small_splashes', type: 'checkbox', multiselect: true, group: 'en407' },
            { label: t("filterFacets.Molten_Metal"), column: 'molten_metal_large_quantities', type: 'checkbox', multiselect: true, group: 'en407' },
        ],
        en511: [
            { label: t("filterFacets.Convective_Cold"), column: 'convective_cold', type: 'checkbox', multiselect: true, group: 'en511' },
            { label: t("filterFacets.Contact_Cold"), column: 'contact_cold', type: 'checkbox', multiselect: true, group: 'en511' },
            { label: t("filterFacets.Water_Penetration"), column: 'water_penetration', type: 'checkbox', multiselect: true, group: 'en511' }
        ],
    };
    const FacetList =
        [
            { label: t("filterFacets.Available_Chempro"), column: 'available_on_chempro', maxItems: 8, type: 'radio', multiselect: false },
            { label: t("filterFacets.Brand"), column: 'brand', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Protection_Type"), column: 'protection_type', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Size"), column: 'size', maxItems: 8, type: 'checkbox', multiselect: true, typeOfFacet: 'number' },
            { label: t("filterFacets.Length"), column: 'length', maxItems: 8, type: 'checkbox', multiselect: true, typeOfFacet: 'number' },
            { label: t("filterFacets.Thickness"), column: 'thickness', maxItems: 8, type: 'checkbox', multiselect: true, typeOfFacet: 'number' },
            { label: t("filterFacets.Color"), column: 'color', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Gauge"), column: 'gauge', maxItems: 8, type: 'checkbox', multiselect: true, typeOfFacet: 'number' },
            { label: t("filterFacets.Grip"), column: 'grip', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Coating_Type"), column: 'coating_type', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Materials"), column: 'material', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Coating_Material"), column: 'coating_material', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Lining_Material"), column: 'lining_material', maxItems: 8, type: 'checkbox', multiselect: true },
            //Specifications
            { column: '', maxItems: 0, group: 'specifications', groupTitle: t("filterFacets.Specifications") },
            { column: '', maxItems: 0, group: 'en374', groupTitle: t("filterFacets.En374") },
            { column: '', maxItems: 0, group: 'en388', groupTitle: t("filterFacets.En388") },
            { column: '', maxItems: 0, group: 'en407', groupTitle: t("filterFacets.En407") },
            { column: '', maxItems: 0, group: 'en511', groupTitle: t("filterFacets.En511") },
            { label: t("filterFacets.Product_Name"), column: 'product_name', maxItems: 8, type: 'checkbox', multiselect: true },
            { label: t("filterFacets.Style_No"), column: 'style_no', maxItems: 8, type: 'checkbox', multiselect: true }

        ];
    //hideLoader
    const hideLoader = async () => {
        setTimeout(() => {
            setShowLoader(false);
        }, 1500);
    };
    //update filter
    useEffect(() => {
        if (checkedFacet?.length > 0) {
            if (checkedFacet.length < (props?.maxFilters || 15)) {
                setShowLoader(true);
                hideLoader();
                const tempFacetColl: string[] = [];
                const updatedFilters: facetFlters = checkedFacet?.map(checkedFacetItem => {
                    if (checkedFacetItem?.indexOf(facetKeySeperator) > -1) {
                        const facetValueDetails = checkedFacetItem?.split(facetKeySeperator);
                        if (facetValueDetails?.[0]?.length > 0 && (facetValueDetails?.[1] == "" || facetValueDetails?.[1]?.length > 0)) {
                            const columnName = facetValueDetails?.[0];
                            const columnNewValues = checkedFacet?.filter(checkedFacetItem => checkedFacetItem?.split(facetKeySeperator)?.[0] == columnName)?.map(key => key && key?.split(facetKeySeperator)?.[1] || "");
                            if (!tempFacetColl?.includes(columnName)) {
                                tempFacetColl.push(columnName);
                                return { [columnName]: [...columnNewValues] };
                            }
                        }
                    }
                }) || [];
                setSelectedfacetQueryFilters(updatedFilters?.filter(updatedFilter => updatedFilter));
                setRefreshKey(Date.now());

            }
            else {
                setShowLoader(false);
            }
        }
        else {
            setShowLoader(false);
            if (props?.flow == FACET_FLOWS.CHEMICAL_RESULTS) {
                props?.setSearchFilters([]);
            }
            setSelectedfacetQueryFilters([]);
            setRefreshKey(Date.now());
        }
        // eslint-disable-next-line
    }, [checkedFacet]);

    //update parent filter
    useEffect(() => {
        if (props?.flow == FACET_FLOWS.CHEMICAL_RESULTS) {
            props?.setSearchFilters(selectedfacetQueryFilters);
        }
        setFilterFacets(selectedfacetQueryFilters);
        // eslint-disable-next-line
    }, [selectedfacetQueryFilters]);
    let languageSelectedForFacets: string = "English (GB)";
    if (language == "de") {
        languageSelectedForFacets = "German";
    } else {
        languageSelectedForFacets = "English (GB)";
    }
    //payload
    const facetPayloadReq = props?.flow == FACET_FLOWS.CHEMICAL_RESULTS ? FACETS_CHEMICAL_BASE_QUERY(selectedfacetQueryFilters, languageSelectedForFacets, styleNumbersData) : FACETS_GLOVE_BASE_QUERY(props?.searchQuery, selectedfacetQueryFilters, languageSelectedForFacets);
    const { data: newDataFacetResults, isLoading: isLoadingFacet } =
        useGetFacetResultsQuery({
            jwtToken: '',
            calculatorId: 'gloveSelector',
            searchType: 'searchGlove',
            appId: '',
            language: language == "de" ? "de-DE" : "en-US",
            HON_ORG_ID: 'SPS',
            payload: JSON.stringify(facetPayloadReq),
        });

    useEffect(() => {

        setSucessMsg(newDataFacetResults?.isSuccess);
        if (newDataFacetResults?.isSuccess == false) {
            setShowAlert(true);
        }
        if (dataFacetResults == null) {
            setDataFacetResults(newDataFacetResults);
        }
        setFilteredFacetResults(newDataFacetResults);

        if (props.flow === FACET_FLOWS.GLOVES_SELECTOR) {
            setGloveResultsInStore(newDataFacetResults);
        }
        if (checkedFacet.length != 0) {
            sendAdobeAnalytics(newDataFacetResults);
        }

        if (props.searchQuery && props.flow == "glove-selector" && props.flag) {


            utilAnalytics(
                true,
                {
                    event: "searchClick",
                    _honeywellinternationalinc:
                    {
                        search:
                        {
                            searchTerm: props.searchQuery,
                            searchResults: newDataFacetResults?.result?.meta?.page?.total_results || 0,
                            secondarySearchTerm: "",
                            searchCategory: "GS-Gloves Selection", // GS-Chemical Selection or GS-Gloves Selection or GS-Info Area"
                            allSearches: { "value": 1 },
                            unsuccessfulSearches:
                            {
                                value: newDataFacetResults?.result?.meta?.page?.total_results == 0 ? 1 : 0
                            }
                        }

                    }

                },
                "/gloves-selector"
            );

        }
        //props.onclick();
        setShowLoader(false);

        // eslint-disable-next-line
    }, [newDataFacetResults, props.flag]);

    const sendAdobeAnalytics = (filterData) => {
        const filterAnalyticData = new Array();
        filterFacets?.forEach((arrayItem) => {
            const entries = Object.entries(arrayItem);
            for (const [key, value] of entries) {
                let newValue: string[] = value as unknown as Array<string>;
                const newKey: string = key;
                const filterDataValue = newValue.toString().replaceAll(",", "|");
                filterAnalyticData.push({ [`${newKey}`]: filterDataValue });
            }
        });
        filterAnalyticData.push({ "totalRecords": filterData?.result?.results?.length || 0 });
        utilAnalytics(
            true,
            {
                event: "chemicalGlovesResult",
                _honeywellinternationalinc:
                {
                    filter:
                    {
                        filterSelected: filterAnalyticData,
                        filterCategory: window.location.href.includes('gloves-selector') ? "GS-Gloves Selection" : "GS-Chemical Selection",
                        filterResults: filterData?.result?.results?.length,
                        selectFilterClicked: { "value": 1 }

                    }
                }
            },
            "/chemical-results"
        );
    }
    //Clear Filters pass blank for all filters
    const clearFilters = useCallback((column, isGroup) => () => {
        let updatedSelectedFacetList: string[] = [];
        if (!isGroup && column?.length > 0) {
            updatedSelectedFacetList = checkedFacet?.filter(checkedFacetItem => checkedFacetItem.indexOf(column + facetKeySeperator) == -1);
        }
        if (isGroup) {
            const facetCoulmns = GroupedFacetList?.[column]?.map(groupedFacet => groupedFacet?.column + facetKeySeperator) || [];
            updatedSelectedFacetList = checkedFacet?.filter(checkedFacetItem => facetCoulmns.filter(facetCoulmn => checkedFacetItem.indexOf(facetCoulmn) > -1).length == 0);
        }
        const uniqueUpdatedFilteredSystems = updatedSelectedFacetList.filter((element, index) => {
            return updatedSelectedFacetList.indexOf(element) === index;
        });
        setShowMoreFacetItemsPanel({});
        setFacetSearchText({});
        setFacetPanelSearchText({});
        setCheckedFacet(uniqueUpdatedFilteredSystems);
        setShowLoader(false);

    }, [checkedFacet]);

    // Add/Remove checked item from list
    const onFacetListGroupNameClick = (column) => (event) => {
        const dataFacetResultsCollection = dataFacetResults?.result?.facets?.[`${column}`]?.[0]?.data;
        let updatedSelectedFacetList = [...checkedFacet];
        const facetkeys: string[] = [];
        const allFacetkeys: string[] = [];
        dataFacetResultsCollection?.forEach(facetValue => {
            if (column && facetValue?.value != undefined) {
                const facetKey = column + facetKeySeperator + facetValue?.value;
                allFacetkeys.push(facetKey);
                if (!updatedSelectedFacetList?.includes(facetKey)) {
                    facetkeys.push(facetKey);
                }
            }
        }
        ) || [];
        if (event.target.checked) {
            if ((updatedSelectedFacetList?.length + facetkeys.length) <= (props?.maxFilters || 15)) {
                updatedSelectedFacetList = [...updatedSelectedFacetList, ...facetkeys];
            }
            else {
                setShowAlert(true);
                setShowLoader(false);
            }

        } else {
            updatedSelectedFacetList = updatedSelectedFacetList.filter(selectedFacet => allFacetkeys?.indexOf(selectedFacet) == -1);
        }
        const uniqueUpdatedFilteredSystems = updatedSelectedFacetList.filter((element, index) => {
            return updatedSelectedFacetList.indexOf(element) === index;
        });
        setCurrentFacet(column);
        setCheckedFacet(uniqueUpdatedFilteredSystems);
    };

    const errorBack = () => {
        if (location.pathname == "/chemical-results") {
            navigate(PAGE_NAVIGATION.CHEMICAL_SEARCH);
        } else {
            navigate(PAGE_NAVIGATION.HOME);
        }

    };
    const errorRefresh = () => {
        navigate(PAGE_NAVIGATION.HOME);
    };

    //add/remove facet vlaues on click
    const onFacetListClick = (column, value, multiselect) => (event) => {
        const facetkey = column + facetKeySeperator + value;
        let updatedSelectedFacetList = [...checkedFacet];

        if (event.target.checked) {
            if ((updatedSelectedFacetList?.length) < (props?.maxFilters || 15)) {
                if (!multiselect) {
                    updatedSelectedFacetList = updatedSelectedFacetList?.filter(selectedFacet => selectedFacet.indexOf(column + facetKeySeperator) == -1);
                }
                updatedSelectedFacetList = [...updatedSelectedFacetList, facetkey];
            }
            else {
                setShowAlert(true);
                setShowLoader(false);
            }

        } else {
            updatedSelectedFacetList.splice(checkedFacet.indexOf(facetkey), 1);
        }
        const uniqueUpdatedFilteredSystems = updatedSelectedFacetList.filter((element, index) => {
            return updatedSelectedFacetList.indexOf(element) === index;
        });
        setCurrentFacet(column);
        setCheckedFacet(uniqueUpdatedFilteredSystems);
    };
    //groupedFacetes -jsx
    const groupedFacetes = (groupName, groupTitle, facetResults) => {

        const facetColumns = GroupedFacetList?.[groupName]?.map(groupedFacet => groupedFacet?.column) || [];

        let facetCoulmnsDataCount = 0;
        const facetkeys: string[] = [];
        const totalFacetsCount = {};
        const totalFacetsValueCount = {};
        const selctedFacetsCount = {};
        facetColumns?.forEach(column => {
            const facetCoulmnData = facetResults?.result?.facets?.[`${column}`]?.[0]?.data || [];
            const facetFilterdColumnData = filteredFacetResults?.result?.facets?.[`${column}`]?.[0]?.data || [];
            let totalCount = 0;
            let totalfacetount = 0;
            let totalSelectedCount = 0;
            facetCoulmnsDataCount = facetCoulmnsDataCount + (facetFilterdColumnData?.length || 0);
            facetFilterdColumnData?.forEach(facetValue => {
                if (column != undefined && facetValue?.value?.length > 0) {
                    const columnKey = (column + facetKeySeperator + facetValue?.value);
                    facetkeys.push(columnKey);
                    totalCount = totalCount + Number(facetValue?.count || "");

                }
            });
            facetCoulmnData?.forEach(facetValue => {
                if (column != undefined && facetValue?.value?.length > 0) {
                    totalfacetount = totalfacetount + 1;
                }
                const columnKey = (column + facetKeySeperator + facetValue?.value);
                if (checkedFacet?.filter(checkedFacetItem => checkedFacetItem === columnKey)?.length > 0) {
                    totalSelectedCount = totalSelectedCount + 1;
                }
            });
            selctedFacetsCount[column] = totalSelectedCount;
            totalFacetsValueCount[column] = totalCount;
            totalFacetsCount[column] = totalfacetount;
        });
        const checkedGroupFacetItems = checkedFacet?.filter(checkedFacetItem => facetkeys?.indexOf(checkedFacetItem) > -1) || [];
        return (<>{
            <div className="filter-panel" id={`filter-panel${groupName}`} key={groupName}>
                <div className="panel-heading">
                    <div className="panel-title" onClick={() => setExpandedFilters({ ...expandedFilters, [`${groupName}`]: !expandedFilters[`${groupName}`] })}>{expandedFilters[`${groupName}`] ? <IoIosArrowUp className="facet-icon" /> : <IoIosArrowDown className="facet-icon" />} {groupTitle}</div>
                    {checkedGroupFacetItems?.length > 0 && <div className='clear-btn' onClick={clearFilters(groupName, true)} >{t("filterFacets.Clear")}</div>}
                    <br />
                </div>
                {(showLoader && facetColumns?.indexOf(currentFacet) > -1) && <div> <Loader customClass="spinner-border spinner-border-md m-2" /></div>}
                {expandedFilters[`${groupName}`] && <div id={`panel-body-${groupName}`}> <div className="panel-body">
                    {GroupedFacetList?.[groupName]?.map((facet, key) => {
                        const facetCoulmnData = facetResults?.result?.facets?.[`${facet?.column}`]?.[0]?.data || [];
                        const facetFilterdCoulmnData = filteredFacetResults?.result?.facets?.[`${facet?.column}`]?.[0]?.data || [];
                        let sortedFacetResults = facetCoulmnData || [];
                        if (sortedFacetResults?.length > 0 && facet?.typeOfFacet == "number") {
                            sortedFacetResults = orderBy(facetCoulmnData?.map((facetCoulm) => { return { ...facetCoulm, "orderBy": Number(facetCoulm.value || "") }; }), "orderBy") || [];
                        }
                        else {
                            sortedFacetResults = orderBy(facetCoulmnData, "value");
                        }
                        sortedFacetResults = sortedFacetResults?.filter((sortedFacet) => sortedFacet?.value?.length > 0);
                        return (sortedFacetResults?.length > 0 ?
                            sortedFacetResults?.map((facetValue, index) => {
                                const latestCount = facetFilterdCoulmnData?.filter((filterdCoulmn) => filterdCoulmn?.value == facetValue?.value)?.[0]?.count || 0;
                                return (
                                    facet?.multiselect ?
                                        <div className="item-select" id={`item-select-${groupName}-${facet?.column}-${facetValue?.value}`}>
                                            {index == 0 && <> <input id={`item-select-checkbox-${groupName}-${facet?.column}-${facetValue?.value}`} checked={((selctedFacetsCount[facet?.column] > 0) && (totalFacetsCount[facet?.column] === selctedFacetsCount[facet?.column]))} name={facet?.column} type={facet?.type} aria-label={groupName} onChange={onFacetListGroupNameClick(facet?.column)} value={groupName} />
                                                <label>{facet?.label} <span>({totalFacetsValueCount[facet?.column]})</span></label></>}
                                            <div className="item-select-sub" id={`item-select-${facet?.column}-${facetValue?.value}`}>
                                                <input disabled={showLoader} id={`input-item-select-${facet?.column}-${facetValue?.value}`} checked={checkedFacet?.indexOf(facet?.column + facetKeySeperator + facetValue?.value) > -1} name={facet?.column} type={facet?.type} aria-label={facetValue?.value} onChange={onFacetListClick(facet?.column, facetValue?.value, facet?.multiselect)} value={facetValue?.value} />
                                                <label htmlFor={`input-item-select-${facet?.column}-${facetValue?.value}`}>{facet?.appendKeyword ? facet?.appendedkeywordText + facetValue?.value : facetValue?.value} <span>({latestCount})</span></label>
                                            </div>
                                        </div>
                                        : (FACET_YES_VALUES?.includes(facetValue?.value?.toLowerCase()) && <div className="item-select" id={`item-select-${facet?.column}-${facetValue?.value}`}>
                                            <input disabled={showLoader} id={`input-item-select-${facet?.column}-${facetValue?.value}`} checked={checkedFacet?.indexOf(facet?.column + facetKeySeperator + facetValue?.value) > -1} name={facet?.column} type={facet?.type} aria-label={facetValue?.value} onChange={onFacetListClick(facet?.column, facetValue?.value, facet?.multiselect)} value={facetValue?.value} />
                                            <label htmlFor={`input-item-select-${facet?.column}-${facetValue?.value}`}>{facet?.appendKeyword ? facet?.appendedkeywordText + facet?.label : facet?.label} <span>({latestCount})</span></label>
                                        </div>)
                                );
                            }
                            )
                            : ""
                        );

                    })}
                </div>  </div>}</div>
        } </>

        );
    };
    // selected item  - jsx
    const selectedFacetItem = (facet, facetValue, latestCount) => {
        return (<div className="item-select" id={`item-select-${facet?.column}-${facetValue?.value}`}>
            <input disabled={showLoader} id={`input-item-select-${facet?.column}-${facetValue?.value}`} checked={checkedFacet?.indexOf(facet?.column + facetKeySeperator + facetValue?.value) > -1} name={facet?.column} type={facet?.type} aria-label={facetValue?.value} onChange={onFacetListClick(facet?.column, facetValue?.value, facet?.multiselect)} value={facetValue?.value} />
            {facet?.column === "color" && <div className={colorCodeAvailable?.includes(facetValue?.value?.replaceAll(/\s/g, '')?.toLowerCase()?.split(" ")?.join("-")) ?
                `circle-${(facetValue?.value?.replaceAll(/\s/g, '') || "")?.toLowerCase()?.split(" ")?.join("-")}` : "circle-no-color"}></div>}
            <label htmlFor={`input-item-select-${facet?.column}-${facetValue?.value}`}>{facet?.appendKeyword ? (facet?.appendedkeywordText + facetValue?.value) : facetValue?.value} <span>({latestCount})</span></label>
        </div>);
    };
    return (
        <>
            {sucessMsg === false ?
                (<>
                    <Modal show={showAlert} onHide={closeWarning} animation={false} aria-labelledby="MaxFilterWarning" centered className="facet-maxfilter-modal">
                        <Modal.Body className="mx-2">
                            <div className="row mx-0">
                                <div className="col-sm-2">
                                    <img src={ImgAlert} alt="Warning" className="warning-icon" />
                                </div>
                                <div className="col-sm-10">
                                    <div className="heading">{t("kclGloves.Error")}</div>
                                    {t("kclGloves.Unable_connect_server")}
                                </div>
                            </div>
                            <div className='cta-btns mt-3 text-end'>
                                <div className="button button-outline" onClick={errorRefresh}>{t("kclGloves.Restart")}</div>
                                <div className="button button-primary" onClick={errorBack}>{t("kclGloves.Go_Back")}</div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </>)
                : (<>  {/* Modal for maximum facet selection*/}
                    <Modal show={showAlert} onHide={closeWarning} animation={false} aria-labelledby="MaxFilterWarning" centered className="facet-maxfilter-modal">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <div className="filters-alert">
                                    <img src={ImgAlert} alt="Maximum 10 Filters" className="warning-icon" /> {t("filterFacets.MaxFilterTitle")}
                                </div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="mx-2">
                            <div className="row mx-0">
                                {t("filterFacets.MaxFilters")?.replace("#CountKey#", props?.maxFilters || "15")}
                            </div>
                        </Modal.Body>
                    </Modal>
                    <div className="filters-heading">
                        <div className="panel-heading-mobile">
                            <div>{t("filterFacets.Filters")} <span className="show-mobile-filters" onClick={() => setShowMobileFilters(!showMobileFilters)}>{showMobileFilters ? <IoIosArrowDown className="facet-icon" /> : <IoIosArrowUp className="facet-icon" />}</span></div>
                            {selectedfacetQueryFilters?.length > 0 && <div className="clear-filters">{/* <span className='active'>Apply</span> */} <span onClick={clearFilters("", false)}>{t("filterFacets.Clear_All")}</span></div>}
                        </div>
                    </div>
                    {showMobileFilters && (
                        <div className="panel-body mobile-panel" key={`${props?.flow}-${refreshKey}`}>
                            {isLoadingFacet && <Loader message="" />}
                            {!isLoadingFacet && dataFacetResults && FacetList?.map((facet, key) => {
                                if (facet?.group && facet?.groupTitle) {
                                    return groupedFacetes(facet?.group, facet?.groupTitle, dataFacetResults);
                                }
                                const facetCoulmnData: [] = dataFacetResults?.result?.facets?.[`${facet?.column}`]?.[0]?.data || [];
                                const facetFilterdCoulmnData = filteredFacetResults?.result?.facets?.[`${facet?.column}`]?.[0]?.data || [];
                                let sortedFacetResults: [] = facetCoulmnData || [];
                                if (sortedFacetResults?.length > 0 && facet?.typeOfFacet == "number") {
                                    sortedFacetResults = orderBy(facetCoulmnData?.map((facetCoulmn: facetColumnData) => { return { ...facetCoulmn, "orderBy": Number(facetCoulmn?.value || "") }; }), "orderBy") as [] || [];
                                }
                                else {
                                    sortedFacetResults = orderBy(facetCoulmnData, "value") as [];
                                }
                                sortedFacetResults = sortedFacetResults?.filter((sortedFacet: facetColumnData) => sortedFacet && sortedFacet?.value?.length > 0) as [];
                                //managing search & search more
                                const searchText = facetSearchText[facet?.column] || "";
                                let searchResultItemCount = 0;
                                if (searchText?.length > 0) {
                                    searchResultItemCount = sortedFacetResults?.filter((facet: facetColumnData) => facet?.value?.toString()?.replace(REGEX_ITEMS.SPACES, '')?.toLowerCase()?.indexOf(searchText?.replace(REGEX_ITEMS.SPACES, '')?.toLowerCase()) > -1)?.length || 0;
                                }
                                const searchMoreText = facetPanelSearchText[facet?.column] || "";
                                let searchPanelResultItems = [];
                                if (searchMoreText?.length > 0) {
                                    searchPanelResultItems = [...sortedFacetResults]?.slice(facet?.maxItems, sortedFacetResults?.length)?.filter((facet: facetColumnData) => facet?.value?.toString()?.replace(REGEX_ITEMS.SPACES, '')?.toLowerCase()?.indexOf(searchMoreText?.replace(REGEX_ITEMS.SPACES, '')?.toLowerCase()) > -1) || [];
                                }
                                const isClerbuttonVisisble = selectedfacetQueryFilters?.filter(selectedfacet => selectedfacet && Object.keys(selectedfacet).indexOf(facet?.column) > -1)?.length > 0;
                                return (sortedFacetResults?.length > 0 &&
                                    <div className="filter-panel" id={`filter-panel${key}`} key={key}>
                                        <div className="panel-heading">
                                            <div className="panel-title" onClick={() => setExpandedFilters({ ...expandedFilters, [`${facet?.column}`]: !expandedFilters[`${facet?.column}`] })}>{expandedFilters[`${facet?.column}`] ? <IoIosArrowUp className="facet-icon" /> : <IoIosArrowDown className="facet-icon" />} {facet?.label}</div>
                                            {isClerbuttonVisisble && <div className='clear-btn' onClick={clearFilters(facet?.column, false)} >{t("filterFacets.Clear")}</div>}
                                            <br />
                                        </div>
                                        {(showLoader && currentFacet == facet?.column) && <div> <Loader customClass="spinner-border spinner-border-md m-2" /></div>}
                                        {sortedFacetResults?.length > facet?.maxItems && expandedFilters[`${facet?.column}`] &&
                                            <div className='search-bar px-0 col-12'>
                                                <span className='search-icon'><BsSearch /></span>
                                                <input disabled={showLoader} type='text' value={facetSearchText[facet?.column] || ""} onChange={(evnt) => setFacetSearchText({ [facet?.column]: evnt.target.value })} placeholder={`| ${t("filterFacets.Search")} ${facet?.label || ""}`} />
                                            </div>}
                                        {(searchText?.length > 0 && searchResultItemCount == 0) && <div className="panel-body">{t("filterFacets.No_Results")}</div>}
                                        {expandedFilters[`${facet?.column}`] && sortedFacetResults?.map((facetValue: facetColumnData, index, key) => {
                                            const latestCount = facetFilterdCoulmnData?.filter((facetFilterdCoulmn: facetColumnData) => facetFilterdCoulmn?.value == facetValue?.value)?.[0]?.count || 0;
                                            return (
                                                <div id={`panel-body-${facet?.column}-${index}`} key={`${refreshKey}`} className="panel-body-colors">
                                                    {searchText?.length > 0 && (facetValue?.value.toString()?.replace(REGEX_ITEMS.SPACES, '')?.toLowerCase()?.indexOf(searchText?.replace(REGEX_ITEMS.SPACES, '')?.toLowerCase()) > -1) &&
                                                        <div className="panel-body" id={`panel-body-${facetValue?.value}`}>
                                                            {selectedFacetItem(facet, facetValue, latestCount)}
                                                        </div>}

                                                    {searchText?.length < 1 && (index < facet?.maxItems) &&
                                                        <div className="panel-body" id={`panel-body-${facetValue?.value}`}>
                                                            {selectedFacetItem(facet, facetValue, latestCount)}
                                                        </div>}

                                                    {<div>
                                                        {searchText?.length < 1 && (index === facet?.maxItems ? <div className="more-items" onClick={() => { setShowMoreFacetItemsPanel({ [`${props?.flow}-${facet?.column}`]: true }); setFacetPanelSearchText({}); }}>+ {(sortedFacetResults?.length - facet?.maxItems)} {t("filterFacets.More")}</div> : "")}
                                                        {searchText?.length < 1 && (showMoreFacetItemsPanel[`${props?.flow}-${facet?.column}`]) && index > facet?.maxItems && (
                                                            <div className="show-thickness">
                                                                <div className="panel-heading">
                                                                    <div className='search-bar px-0 col-12'>
                                                                        <span className='search-icon'><BsSearch /></span>
                                                                        <input disabled={showLoader} type='text' value={facetPanelSearchText[facet?.column] || ""} onChange={(evnt) => setFacetPanelSearchText({ [facet?.column]: evnt.target.value })} placeholder={`| ${t("filterFacets.Search")} ${facet?.label || ""}`} />
                                                                    </div>
                                                                    <AiOutlineClose className="icon-close" onClick={() => { setShowMoreFacetItemsPanel({}); setFacetPanelSearchText({}); }} />
                                                                </div>
                                                                {(showLoader && currentFacet == facet?.column) && <div> <Loader customClass="spinner-border spinner-border-md m-2" /></div>}
                                                                {(searchMoreText?.length > 0 && searchPanelResultItems?.length == 0) && <div className="panel-body">{t("filterFacets.No_Results")}</div>}
                                                                <div className="panel-body" id={`panel-body-${facetValue?.value}`}>
                                                                    {searchMoreText?.length > 0 && searchPanelResultItems?.length > 0 && searchPanelResultItems?.map((facetValue, index, key) => {
                                                                        return selectedFacetItem(facet, facetValue, latestCount);

                                                                    })}
                                                                    {searchMoreText?.length < 1 && [...sortedFacetResults]?.slice(facet?.maxItems, sortedFacetResults?.length)?.map((facetValue, index, key) => {
                                                                        return selectedFacetItem(facet, facetValue, latestCount);
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    }
                                                </div>

                                            );
                                        }
                                        )
                                        }
                                    </div>
                                );
                            })}

                        </div>
                    )}
                    <ChemicalResultsPDF data={selectedfacetQueryFilters} />
                </>)}
        </>
    );
};

export default FilterFacets;